/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
import type { Email } from './Email';
import type { Operators } from './Operators';
import type { Store } from './Store';
export type User = {
    /**
     * The unique ID of the user.
     */
    userID: string;
    /**
     * FusionAuth user ID.
     */
    fusionAuthUserId?: string;
    /**
     * API token.
     */
    apiToken?: string;
    /**
     * The first name of the user.
     */
    firstName?: string;
    /**
     * The last name of the user.
     */
    lastName?: string;
    /**
     * The gender of the user.
     */
    gender?: string;
    /**
     * The age of the user.
     */
    age?: number;
    /**
     * The phone number of the user.
     */
    phoneNumber?: string;
    /**
     * Type of the user.
     */
    userType?: User.userType;
    /**
     * Is this user active?
     */
    active?: boolean;
    /**
     * Can delete this User?
     */
    blocked?: boolean;
    /**
     * The mail addresses of the user.
     */
    addresses?: Array<Address>;
    /**
     * The e-mail addresses of the user.
     */
    emails?: Array<Email>;
    /**
     * Operators
     */
    operators?: Operators;
    /**
     * Further user data.
     */
    data?: string;
    /**
     * Did this user subscribe to newsletters?
     */
    recommendationAndFootwearConsent?: boolean;
    /**
     * Did this user agree to analytics data collection?
     */
    researchAndImprovementsConsent?: boolean;
    /**
     * The stores the user is assigned to.
     */
    stores: Array<Store>;
};
export namespace User {
    /**
     * Type of the user.
     */
    export enum userType {
        PATIENT = 'PATIENT',
        OPERATOR = 'OPERATOR',
    }
}

